<template>
  <div class="margin-bottom8px">
    <md-card>
      <md-card-header>
        <div class="md-title">Create eForm : New</div>
      </md-card-header>
      <div>LL : {{ this.eFormData }}</div>
      <md-card-content>
        <b-tabs
          active-nav-item-class="font-weight-bold text-uppercase"
          content-class="mt-3"
        >
          <b-tab title="GENERAL" active>
            <b-row>
              <b-col lg="3" class="margin-bottom8px">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="eFormData.FormShotName"
                    maxlength="20"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0,this.maxLength);"
                    placeholder="Form shot name"
                    title="Form shot name"
                    v-b-tooltip.hover
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="3" class="margin-bottom8px">
                <md-button class="md-dense md-raised md-primary">{{
                  this.eFormData.FormShotName
                }}</md-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6" class="margin-bottom8px">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="eFormData.FormName"
                    placeholder="Form name"
                    title="Form name"
                    v-b-tooltip.hover
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="6" class="margin-bottom8px">
                <b-input-group size="sm">
                  <template v-slot:prepend>
                    <b-input-group-text>Add subform name</b-input-group-text>
                  </template>
                  <b-input-group-append>
                    <b-button
                      variant="success"
                      @click="AddSubformName(eFormData.SubformNameList.length)"
                      title="Add subform name"
                      v-b-tooltip.hover
                    >
                      <v-icon
                        name="plus-circle"
                        class="icon-custom-input-group-sm"
                      ></v-icon>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>

            <md-card
              v-for="(itemSubformName, itemSubformIndex) in evenOrderBy(eFormData.SubformNameList)"
              v-bind:key="itemSubformName.id"
              class="margin-top8px"
            >
              <md-card-content>
                <b-row>
                  <b-col lg="9" class="margin-bottom8px">
                    <b-input-group  size="sm">
                      <template v-slot:prepend variant="success" >
                        <b-input-group-text >{{ (itemSubformIndex+1) }}.</b-input-group-text>
                      </template>
                      <b-form-input
                        placeholder="Subform name"
                        v-model="itemSubformName.SubformName"
                        title="Subform name"
                        v-b-tooltip.hover
                      ></b-form-input>
                      <b-form-input
                        v-model="itemSubformName.OrderBy"
                        type="number"
                        placeholder="Order by"
                        style="max-width:60px;"
                        title="Order by"
                        v-b-tooltip.hover
                      ></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="3" class="margin-bottom8px">
                    <b-input-group size="sm">
                      <template v-slot:prepend>
                        <b-input-group-text>Add question</b-input-group-text>
                      </template>
                      <b-input-group-append>
                        <b-button
                          variant="success"
                          @click="AddQuestion(itemSubformName.QuestionList, itemSubformName.QuestionList.length)"
                          title="Add question"
                          v-b-tooltip.hover
                        >
                          <v-icon
                            name="plus-circle"
                            class="icon-custom-input-group-sm"
                          ></v-icon>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>

                <div
                  v-for="(itemQuestion, itemQuestionIndex) in evenOrderBy(itemSubformName.QuestionList)"
                  v-bind:key="itemQuestion.id"
                  class="margin-left8px"
                >
                  <!-- sssssssssssssssssssssssssss -->
                  <b-row class="margin-top8px">
                    <b-col>
                      <hr class="hr-custom" />
                    </b-col>
                  </b-row>
                  <b-row >
                    <b-col lg="8" class="margin-bottom8px">
                      <b-input-group size="sm">
                        <template v-slot:prepend variant="success" >
                          <b-input-group-text >{{ (itemQuestionIndex+1) }}.</b-input-group-text>
                        </template>
                        <b-form-input
                          placeholder="Question"
                          v-model="itemQuestion.QuestionName"
                          title="Question text"
                          v-b-tooltip.hover
                        ></b-form-input>
                        <b-form-select
                          size="sm"
                          v-model="itemQuestion.QuestionType"
                          :options="SelectOptions"
                          style="max-width:100px;"
                          title="Question type"
                          v-b-tooltip.hover
                        >
                        </b-form-select>
                        <b-form-input
                          v-model="itemQuestion.OrderBy"
                          type="number"
                          placeholder="Order by"
                          style="max-width:60px;"
                          title="Order by"
                          v-b-tooltip.hover
                        ></b-form-input>
                      </b-input-group>
                    </b-col>
                    <b-col lg="3" class="margin-bottom8px">
                      <b-input-group size="sm">
                        <template v-slot:prepend>
                          <b-input-group-text>Add choice</b-input-group-text>
                        </template>
                        <b-input-group-append>
                          <b-button
                            variant="success"
                            @click="AddChoice(itemQuestion.ChoiceList, itemQuestion.ChoiceList.length)"
                            title="Add choice"
                            v-b-tooltip.hover
                          >
                            <v-icon
                              name="plus-circle"
                              class="icon-custom-input-group-sm"
                            ></v-icon>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      lg="4"
                      v-for="itemChoice in evenOrderBy(itemQuestion.ChoiceList)"
                      v-bind:key="itemChoice.id"
                    >
                      <b-input-group size="sm" class="mb-2">
                        <b-input-group-prepend is-text>
                          <input
                            v-if="itemQuestion.QuestionType == 'Radio'"
                            :name="'Choice' + itemQuestion.QuestionID"
                            type="radio"
                          />
                          <input
                            v-if="itemQuestion.QuestionType == 'Checkbox'"
                            :name="'Choice' + itemChoice.ChoiceID"
                            type="checkbox"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="itemChoice.ChoiceName"
                          title="Choice text"
                          v-b-tooltip.hover
                        ></b-form-input>
                        <b-form-input
                          v-model="itemChoice.ChoicePoint"
                          type="number"
                          placeholder="Point"
                          style="max-width:60px;"
                          title="Point"
                          v-b-tooltip.hover
                        ></b-form-input>
                        <b-form-input
                          v-model="itemChoice.OrderBy"
                          type="number"
                          placeholder="Order by"
                          style="max-width:60px;"
                          title="Order by"
                          v-b-tooltip.hover
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            variant="danger"
                            @click="AddChoice(itemQuestion.ChoiceList, itemQuestion.ChoiceList.length)"
                            title="Remove choice"
                            v-b-tooltip.hover
                          >
                            <v-icon
                              name="x"
                              class="icon-custom-input-group-sm"
                            ></v-icon>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </div>
              </md-card-content>
            </md-card>
          </b-tab>
          <b-tab title="SETTING">
            dfsdfdsfsdfds
          </b-tab>
        </b-tabs>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import axios from "axios";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

import Vue2Filters from 'vue2-filters';

Vue.use(Vue2Filters)

@Component({
  props: ["MyEformId"],
  component: {
    store,
    axios,
    thaiDatetime,
    pjFunctions
  },
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      lang: {
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        },
        MyScanDate: this.MyScanDate,
        MyHn: this.MyHn,
        MyScanType: this.MyScanType
      },
      SelectOptions: [
        { value: "Radio", text: "Radio" },
        { value: "Checkbox", text: "Checkbox" }
      ],
      currentOrder: 'OrderBy',
      eFormData: {
        FormShotName: "",
        FormName: "",
        SubformNameList: []
      }
    };
  },
  mounted() {},
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {},
  methods: {
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    evenOrderBy: function(arr) {
      // Set slice() to avoid to generate an infinite loop!
      return arr.slice().sort(function(a, b) {
        return a.OrderBy - b.OrderBy;
      });
    },
    AddSubformName(OrderBy) {
      let id = this.pjFunctionsFc.RandomString(15);
      let SubformName = {
        SubformNameID: id,
        SubformName: "",
        OrderBy: (OrderBy+1),
        QuestionList: []
      };
      this.eFormData.SubformNameList.push(SubformName);
    },
    AddQuestion(QuestionList, OrderBy) {
      let id = this.pjFunctionsFc.RandomString(15);
      let Question = {
        QuestionID: id,
        QuestionName: "",
        QuestionType: "Radio",
        OrderBy: (OrderBy+1),
        ChoiceList: []
      };
      QuestionList.push(Question);
    },
    AddChoice(ChoiceList, OrderBy) {
      let id = this.pjFunctionsFc.RandomString(15);
      let Choice = {
        ChoiceID: id,
        ChoiceName: "",
        ChoicePoint: 0,
        OrderBy: (OrderBy+1)
      };
      ChoiceList.push(Choice);
    }
  }
})
export default class eFormAdds extends Vue {}
</script>


<style lang="scss">
</style>
